import React, {useEffect} from 'react';
import {Card, CardContent, CardActionArea, Paper, Box,
  ListItem, List, Typography, Grid, Divider, CardMedia} from '@mui/material';
import { Whatshot,Visibility } from '@mui/icons-material';
import style from '../../css/About.module.css';
import image from '../../other/image/MPQ200.png';
import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useSelector } from 'react-redux';
import { data } from '../../storeredux';

gsap.registerPlugin(ScrollTrigger)

export default function About() {
  const visimisi = useSelector(data)

  useEffect(()=>{
    let tl = gsap.timeline({
      scrollTrigger:{
        trigger:'#con-a',
        start:'top center',
        end:'+=400',
        scrub:0,
      },
    });
    tl.from('#con-a',{opacity:0, x:100, ease:'power4'})
      .from('#tit-a',{opacity:0, x:-100, ease:'power4'})
      .from('#ico-a',{opacity:0, x:100, ease:'power4'})
      .from('#visi-a',{opacity:0, x:-100, ease:'power4'})
      .from('#misi-a',{opacity:0, x:100, ease:'power4'});
    gsap.from("#tit-ab",{scrollTrigger:{
      trigger:'#tit-ab',
      start:'top center',
      scrub:0,
    },opacity:0, x:100, ease:'power4'})
  },[])

  return(
    <>
      <Box id='About' sx={{display:'flex', alignItems:'center', justifyContent:'center', flexWrap:'wrap'}}>
        <Box id='con-a' style={{marginTop: '50px',width:'100%',marginBottom:'40px'}}>
          <Box sx={{backgroundColor:'#66ff66', top:'10vh', left:'10vw',
            height: '50px', width: {xs:'30vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
          <Box sx={{backgroundColor:'#66ff33', top:'12vh', right:'2vw',
            height: '50px', width: {xs:'30vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
          <Box id='tit-a' display='flex'>
            <Typography variant='h3' style={{backgroundColor:'#33cc33'}}>
              <span className={style.titleMain}><b>About Us</b></span>
            </Typography>
          </Box>
          <Divider variant='fullWidth' style={{backgroundColor:'#33cc33',height:'5px'}}/>
        </Box>
        <Paper id='tit-ab' elevation={4} className={style.container1} sx={{width:'100%',maxWidth:'700px',overflow:'hidden'}} square>
          <Grid container style={{alignItems:'start',justifyContent:'center'}} spacing={2}>
            <Grid item xs={12} style={{alignItems:'center',justifyContent:'center',display:'flex',background:'#37c43c'}}>
              <Typography variant='h5' style={{color: '#ffff',padding: '40px'}}>
                <span className={style.title}><b>MPQ UMS</b></span>
              </Typography>
            </Grid>
            <Grid item xs={12} style={{alignItems:'center',justifyContent:'center',display:'flex'}}>
              <Card id='ico-a' elevation={0} style={{backgroundColor:'#f5f5ef', padding:'8px'}}>
                <CardMedia image={image} alt="Icon MPQ" sx={{width:'100px',height:'100px'}}/>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Grid container style={{flexWrap:'wrap', alignItems:'center', justifyContent:'center', display:'flex'}} spacing={2}>
                <Grid item xs={11}>
                  <Card id='visi-a' elevation={12} style={{borderRadius:10, width: '100%'}}>
                    <CardActionArea className={style.cardController}>
                      <CardContent className={style.cardContentVisi}>
                        <Visibility fontSize='large' />
                        <Typography variant='h6' fontFamily={'Trebuchet MS'}>Visi</Typography>
                      </CardContent>
                      <CardContent className={style.cardContentBody}>
                        <List>
                          {
                            (visimisi['visi'].length > 0)?
                            visimisi['visi'].map((a,i) => (
                                  <ListItem key={i} sx={{color:'#164970'}}>
                                    <Typography variant='body1'>
                                      {i+1}. {a}
                                    </Typography>
                                  </ListItem>
                            )):
                            <Paper elevation={10} style={{borderRadius:5,backgroundColor:'#ffb380',
                              marginTop:'5%',marginBottom:'5%'}}>
                              <Typography variant='h5' style={{color:'#ff6600',textAlign:'center',padding:'10px'}}>
                                Visi is Empty
                              </Typography>
                            </Paper>
                          }
                        </List>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
                <Grid item xs={11}>
                  <Card id='misi-a' elevation={12} style={{borderRadius:10, width: '100%'}}>
                    <CardActionArea className={style.cardController}>
                      <CardContent className={style.cardContentMisi}>
                        <Whatshot fontSize='large'/>
                        <Typography variant='h6' fontFamily={'Trebuchet MS'}>Misi</Typography>
                      </CardContent>
                      <CardContent className={style.cardContentBody}>  
                        <List>
                          {
                            (visimisi['misi'].length > 0)? 
                              visimisi['misi'].map((a,i) => (
                                    <ListItem key={i} sx={{color:'#c95d10'}}>
                                      <Typography variant='body1'>
                                        {i+1}. {a}
                                      </Typography>
                                    </ListItem>
                            )):
                            <Paper elevation={10} style={{borderRadius:5,backgroundColor:'#ffb380',
                              marginTop:'5%',marginBottom:'5%'}}>
                              <Typography variant='h5' style={{color:'#ff6600',textAlign:'center',padding:'10px'}}>
                                Misi is Empty
                              </Typography>
                            </Paper>
                          }
                        </List>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </>
  )
}
